import React, { useEffect, useState } from 'react';
import { Auth as AWSAuth} from 'aws-amplify';

export const AutoLogout = () => {
  const [signoutTime, setSignoutTime] = useState(3600000);
  
  let logoutTimeout: ReturnType<typeof setTimeout>;
  
  const logout = () => {
    AWSAuth.signOut();
    console.log('You have been logged out');
  }

  const setTimeouts = () => {
    logoutTimeout = setTimeout(logout, signoutTime);
  };

  const clearTimeouts = () => {
    if (logoutTimeout) clearTimeout(logoutTimeout);
  };

  useEffect(() => {

    const events = [
      'load',
      'mousemove',
      'mousedown',
      'click',
      'scroll',
      'keypress'
    ];

    const resetTimeout = () => {
      clearTimeouts();
      setTimeouts();
    };

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }

    setTimeouts();
    return () => {
      for(let i in events){
        window.removeEventListener(events[i], resetTimeout);
        clearTimeouts();
      }
    }
  },[]);
}
